<div class="snowflake-access">
<h1>Snowflake Access</h1>
<div>
    <h2>Database Access</h2>
    <p>The access Snowflake, use the following details:</p>
    <ul>
        <li>Host: {{snowflakeAccount}}</li>
        <li>Database: {{snowflakeDatabase}}</li>
        <li>Schema: {{snowflakeSchema}}</li>
        <li>Warehouse: {{snowflakeWarehouse}}</li>
    </ul>
    <h2>User Access</h2>
    <div *ngIf="snowflakeUser">
        <p>Your account is active and you will be able to authenticate with your Scaffold credentials. If you have any
            issues, you can attempt to reset your credentials</p>
        <button pButton severity="primary" (click)="resetSnowflakeUser()">Reset</button>
    </div>
    <div *ngIf="!snowflakeUser">
        <p>Your account is not active, do you want to activate it?</p>
        <button pButton severity="primary" (click)="activateSnowflakeUser()" *ngIf="!snowflakeUser">Activate</button>
    </div>
</div>
</div>